import { createAdvancedOrderProduct, contactFormTemplate } from '../global'
import { initSwiperGallery } from './gallery'
import { scrollToElement, isMobile, createSwiperProductBlocks } from '../base'

function moveAddDetailElements() {
    $('.p-code').insertBefore('.ratings-and-brand')
    $('.p-final-price-wrapper').insertBefore('.p-short-description')
    $('.p-final-price-wrapper .price-standard').appendTo('.price-final');
    $('<div class="availability-wrapper"></div>').appendTo('.price-measure');
    $('.p-data-wrapper .availability-wrapper').append($('.detail-parameters tr:has(.availability-label)'))
    $('.p-short-description p:last').append(`<div class="scroll-to-description">Mehr</div>`)
    $('.p-short-description').append(`<a href="/vypocet-spotreby" class="calculate">Verbrauch berechnen</a>`)
    $('.detail-parameters.shipping-options-layout').appendTo('.p-final-price-wrapper')

    const rows = `
        <div class="p-row icon icon--delivery">          
            <p>Versandkosten</p>          
        </div>
        <div class="p-row icon icon--paint">
            <p>Möchten Sie renovieren?</p>
            <a href="/nezavazna-poptavka">Unverbindlich anfragen</a>
        </div>
    `;

    const info = `
        <div class="p-info icon icon--delivery">          
            <p>Bestellungen an Werktagen bis 14:00 Uhr werden am selben Tag versandt</p>
        </div>
        <div class="p-info icon icon--return">         
            <p>Rückerstattung innerhalb von 14 Tagen</p>    
        </div>
        <div class="p-info icon icon--payment">
            <p>Sichere Online-Kartenzahlung</p>          
        </div>
    `;


    $('<div class="p-rows"></div>').appendTo('.p-final-price-wrapper');
    $('.p-rows').append(rows);
    $('.shipping-options').appendTo('.icon--delivery');

    $('<div class="p-infos"></div>').appendTo('.p-to-cart-block');
    $('.p-infos').append(info);
    $('.detail-parameters.shipping-options-layout').appendTo('.p-info.icon--delivery');

    // Popis produktu
    if (!isMobile()) {
        $('.basic-description').prepend(`<h2>Popis</h2>`)
    }

    // Sdileni
    if (!$('.social-buttons .instagram, .social-buttons .mail').length) {
        const productName = $('.p-detail-inner-header h1').first().text().trim();
        const mailtoLink = `mailto:?subject=${encodeURIComponent(productName)}&body=${encodeURIComponent(window.location.href)}`;

        $('.social-buttons .facebook').after(`
        <a href="https://www.instagram.com" target="_blank" class="instagram">
            <img src="/user/documents/able-images/icons/instagram.svg" alt="">
            Teilen
        </a>
        <a href="${mailtoLink}" class="mail">
            <img src="/user/documents/able-images/icons/mail.svg" alt="">
            Teilen
        </a>
    `);
    }

    // Scroll to description
    $('.scroll-to-description').on('click', handleScrollToDescription)

    // Text nad názvem produktu - může se přidat hodnocení produktu, kód produktu, značka apod.
    upperTitleText()
}

function upperTitleText() {
    if (isMobile()) {
        $('.p-detail-inner-header-mobile .h1').after(`<div class = "upper-title-text"></div>`)
    } else {
        $('.p-detail-inner-header').before(`<div class = "upper-title-text"></div>`)
    }
}

function addImageAndPriceToAdvancedOrderDetail() {
    const image = $('.p-image img').attr('src')
    const price = $('.price-final-holder:not(.no-display)').text();
    const name = getShoptetDataLayer('product').name
    const availability = $('.availability-wrapper .availability-label').text();

    createAdvancedOrderProduct({image, price, name, availability})
}

function handleScrollToDescription() {
    const scrollLocation = $('#tab-content').length ? $('#tab-content') : $('.accordion-content')
    scrollToElement(scrollLocation)

    const firstTab = $('.custom-tab-link').first()
    const nextSibling = firstTab.next()

    setTimeout(() => {
        firstTab.addClass('open')
        setTimeout(() => nextSibling.addClass('active'), 200)
        setTimeout(() => nextSibling.removeClass('fade'), 230)
    }, 350)
}

function moveDescriptionVideo() {
    const iframes = $('.basic-description iframe');

    if (iframes.length) {
        const iframeWrapper = $('<div class="detail-video"><p>Video návod</p></div>');
        iframeWrapper.append(iframes);
        $('.extended-description').append(iframeWrapper);
    }
}

function addContactForm() {
    // Add contact form
    $(contactFormTemplate({productForm: true})).insertAfter('.p-detail-tabs-wrapper')
}

function detailTextChanges() {
}

export function initDetail() {
    // Add detail elements
    moveAddDetailElements()
    detailTextChanges()
    moveDescriptionVideo()
    // addContactForm()

    // Gallery
    initSwiperGallery()

    // Products slider
    createSwiperProductBlocks()

    // mezikošík
    addImageAndPriceToAdvancedOrderDetail()

    document.addEventListener('ShoptetSplitVariantParameterChange', () => {
        setTimeout(() => {
            addImageAndPriceToAdvancedOrderDetail()
        }, 100)
    })
}
